import { render, staticRenderFns } from "./ShoppingList.vue?vue&type=template&id=4a3b0f4e&scoped=true&"
import script from "./ShoppingList.vue?vue&type=script&lang=js&"
export * from "./ShoppingList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a3b0f4e",
  null
  
)

export default component.exports